export const UserModule = {
    namespaced: true,
    state: {
        accessToken: "",
        roleId: null,
        isActiveToken: null,
        userInfo: {},
        
        loadTeamMemberData: 1,
        TeamMemberList: [],
        TeamMemberFilterList: [],
        TeamMemberImgFilterList: [],
        ActiveTeamsList: [],
        ActiveTeamsFilterList: [],
        totalRecord: 0,
        totalLenght: 0,
        tableLoader: 1,
        teamList: [],
    }
}